import styled from 'styled-components';

export const Container = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Content = styled.div`
  width: 100%;
  height: 100%;
  max-width: 1220px;
  margin: 0 40px;
  display: flex;
  flex-direction: column;
`;

export const Route = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 36px;
  padding: 8px 0;
  border-bottom: 1px solid #888;
`;

export const CollectRequesterTypeTitle = styled.p`
  color: #004e9a;
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  text-transform: uppercase;
`;

export const CollectRequesterTypeText = styled.p`
  color: #004e9a;
  font-weight: bold;
  text-align: center;
`;

export const Title = styled.p`
  font-weight: bold;
`;

export const TextSameLine = styled.div`
  display: flex;
  color: #888888;
  justify-content: space-around !important;
  width: 100%;
  flex: 1;
  flex-direction: row;
  text-align: center;

  @media (max-width: 480px) {
    flex-direction: column;
    text-aligm: center;
  }
`;

export const ColumnText = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: center;
  padding: 5px;

  > span {
    margin: 15px 15px;
  }
`;
